module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/es-abstract/helpers/sign.js
// module id = 638
// module chunks = 168707334958949